import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const ErrorIcon: FC<IconProps> = ({color = theme.palette.error.contrastText, size}) => (
  <Icon size={size}>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.2348 1.75C14.0519 1.75 14.8048 2.19301 15.2016 2.9073L18.535 8.9073C18.9125 9.58685 18.9125 10.4131 18.535 11.0927L15.2016 17.0927C14.8048 17.807 14.0519 18.25 13.2348 18.25L6.76521 18.25C5.94808 18.25 5.19519 17.807 4.79836 17.0927L1.46502 11.0927C1.0875 10.4131 1.08749 9.58685 1.46502 8.9073L4.79836 2.9073C5.19519 2.19301 5.94809 1.75 6.76521 1.75H13.2348Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <rect x="9.25" y="12" width="1.5" height="1.5" rx="0.5" fill={color} />
      <rect x="9.25" y="6" width="1.5" height="4" rx="0.5" fill={color} />
    </svg>
  </Icon>
)
